import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfigService } from './services/config.service';
import { ErrorService } from './services/error.service';
import { LoggerService } from './services/logger.service';
import { ApiService } from './services/api.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private critical = ['/token', '/configuration'];

  constructor(
    private configService: ConfigService,
    private errorService: ErrorService,
    private apiService: ApiService,
    private logger: LoggerService
  ) {}

  handleError(error: Error | HttpErrorResponse): void {
    const isErrorLoggerServiceActive = this.configService.get() && this.configService.get().logErrors;

    if (error instanceof HttpErrorResponse) {
      if (this.critical.some((c) => error.url.includes(c))) {
        this.configService.initError = true;
      } else {
        this.errorService.handleError(error, isErrorLoggerServiceActive);
      }
    } else {
      this.logger.error(error);
      if (isErrorLoggerServiceActive) {
        const newRuntimeError = {
          type: 'runtime',
          message: error.message,
          stackTrace: error.stack,
        };
        this.apiService.logNewUnhandledError(newRuntimeError).subscribe();
      }
    }
  }
}
